export default function VideoListSkeleton() {
  return <div></div>;
}
